var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-5",class:{
    'mr-sm-16 guest-message': _vm.message.type === 1,
    'ml-sm-16 host-message': _vm.message.type === 2,
  },attrs:{"loading":_vm.loading,"color":_vm.message.type === 1 ? 'secondary' : ''}},[(_vm.message.subject)?_c('v-card-title',{staticClass:"pt-3 pb-1"},[_vm._v(" "+_vm._s(_vm.message.subject)+" ")]):_vm._e(),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.message.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }